<template>
  <div id="c-mv" class="c-mv">
    <div ref="c-mv__thumb" class="c-mv__thumb">
      <div class="is-thumb"></div>
    </div>
    <div class="c-mv__info">
      <div ref="is-title" class="is-title">
        <img :src="`${$store.getters.assetsPath}img/top/mv/mv-9999@2x.png`" alt="999.9 NEW COLLECTION 2022-2023" width="259" height="159" />
        <img :src="`${$store.getters.assetsPath}img/top/mv/mv-line@2x.png`" alt="" width="259" />
      </div>
      <h1 ref="c-luxury" class="c-luxury"><img :src="`${$store.getters.assetsPath}img/top/mv/mv-title@2x.png`" alt="L" width="100" height="119" /></h1>
      <div ref="c-btnScroll" class="c-btnScroll" @click="scrollMV">
        <svg class="c-btnScroll__svg" xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120">
          <circle cx="60" cy="60" r="60" />
        </svg>
        <span class="c-btnScroll__arrow"></span>
      </div>
    </div>
    <div class="c-mv__frame"></div>
  </div>
</template>

<script>
import { gsap, Quart } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);

export default {
  data() {
    return {
      bgImgs: null,
    }
  },
  computed: {
  },
  mounted() {
    // 背景画像
    this.bgImgs = this.$refs['c-mv__thumb'].querySelectorAll('.is-thumb');
    gsap.set(this.bgImgs, {
      filter: 'brightness(8)',
      scale: 1.2,
      autoAlpha: 0, 
    });

    // Scrollボタン
    gsap.set(this.$refs['c-btnScroll'], {
      autoAlpha: 0, 
      y: 40,
    });
    gsap.set(this.$refs['c-btnScroll'].querySelector('.c-btnScroll__svg circle'), {
      rotation: 0,
      'stroke-dasharray': 0,
    });
    gsap.set(this.$refs['c-btnScroll'].querySelector('.c-btnScroll__arrow'), {
      autoAlpha: 0, 
      y: '-25%',
    });

    // タイトル
    gsap.set(this.$refs['is-title'], {
      autoAlpha: 0,
      scale: 1.2,
      filter: 'blur(12px)',
      webkitFilter: 'blur(12px)',
    });

    gsap.set(this.$refs['c-luxury'], {
      autoAlpha: 0,
      scale: 1.2,
      filter: 'blur(12px)',
      webkitFilter: 'blur(12px)',
    });
  },
  methods: {
    start() {
      gsap.to(this.bgImgs[0], {
        duration: 2.0,
        filter: 'brightness(1)',
        autoAlpha: 1,
        scale: 1,
        clearProps: 'all',
        ease: Quart.easeOut,
      });

       // タイトル
       gsap.to(this.$refs['is-title'], {
        duration: 1.6,
        delay: 0.6,
        autoAlpha: 1.0,
        scale: 1.0,
        filter: 'blur(0px)',
        webkitFilter: 'blur(0px)',
        clearProps: true,
        ease: Quart.easeInOut,
      });

      gsap.to(this.$refs['c-luxury'], {
        duration: 1.6,
        delay: 0.7,
        autoAlpha: 1.0,
        scale: 1.0,
        filter: 'blur(0px)',
        webkitFilter: 'blur(0px)',
        clearProps: true,
        ease: Quart.easeInOut,
      });

      setTimeout(this.startComp, 2000);
    },
    startComp() {
      // Scrollボタン表示
      const tlBtn = gsap.timeline();
      tlBtn.to(this.$refs['c-btnScroll'], {
        duration: 1.0,
        autoAlpha: 1.0,
        y: 0,
        clearProps: 'all',
        ease: Quart.easeOut,
      }, 0);
      tlBtn.to(this.$refs['c-btnScroll'].querySelector('.c-btnScroll__svg circle'), {
        duration: 1.0,
        rotation: 90,
        'stroke-dasharray': 377,
        //clearProps: 'transform',
        ease: Quart.easeInOut,
      }, 0);
      tlBtn.to(this.$refs['c-btnScroll'].querySelector('.c-btnScroll__arrow'), {
        duration: 0.7,
        autoAlpha: 1.0,
        y: '0%',
        ease: Quart.easeOut,
      }, 1.0);
      tlBtn.play();
    },
    scrollMV() {
      gsap.to(window, {
        duration: 0.7,
        scrollTo: {
          y: window.innerHeight,
          autoKill: false,
        },
        ease: Quart.easeOut,
      });
    },
    reset() {
      gsap.set(this.$refs['c-btnScroll'], {clearProps: 'all'});
      gsap.set(this.$refs['c-btnScroll'].querySelector('.c-btnScroll__svg circle'), {clearProps: 'all'});
      gsap.set(this.$refs['c-btnScroll'].querySelector('.c-btnScroll__arrow'), {clearProps: 'all'});
    }
  }
}
</script>